// One guard at the transport boundary covers persistent deletions from every UI.
export const deletionRequestNeedsConfirmation = (request = {}) => {
  if (request.deleteConfirmation === false) return false;
  const method = String(request.method || "get").toLowerCase();
  const path = String(request.url || "").split("?")[0];
  if (!/\/afterlogin\//.test(path)) return false;
  return method === "delete" || /\/(?:delete|deleteall|destroy)(?:\/|$)/i.test(path)
    || /\/campaigndelete$/i.test(path) || /\/stripe\/defaultcardremove$/i.test(path);
};

export const installDeleteConfirmation = (client, dialog) => client.interceptors.request.use(async (request) => {
  if (!deletionRequestNeedsConfirmation(request)) return request;
  const result = await dialog.fire({
    title: "Confirm deletion",
    text: "Type DELETE to complete this action.",
    input: "text", inputPlaceholder: "DELETE", inputAutoTrim: false,
    inputAttributes: { autocomplete: "off", "aria-label": "Type DELETE to confirm" },
    inputValidator: (value) => value === "DELETE" ? undefined : "Please type DELETE exactly.",
    showCancelButton: true, confirmButtonText: "Delete", cancelButtonText: "Cancel",
    allowOutsideClick: false, reverseButtons: true,
  });
  if (result.isConfirmed && result.value === "DELETE") return request;
  throw new client.CanceledError("Deletion cancelled");
});
